<a [tkDialogClose]="true" class="arrow-back">
	<tk-icon icon="arrow_back" size="24" />
	<span class="arrow-back__text">Назад</span>
</a>
